module.exports = __webpack_public_path__ + "img/model2.19a0d66f.png";